import { useAppDispatch, useAppSelector } from '../../../../state/hooks'
import {
  saleSubmittedEarly,
  selectPayAccountBalance,
} from '../../../../state/slices/currentSale/currentSaleSlice'
import { useSaleManager } from '../../../../ng-compat/hooks'
import { $state } from '../../../../ng-compat/imports'
import { STATES } from '../../../../../../lib/routes'

export const useGoConfirmation = () => {
  const dispatch = useAppDispatch()
  const saleManager = useSaleManager()
  const payAccountBalance = useAppSelector(selectPayAccountBalance)

  /**
   * Navigate to the sale confirmation screen.
   * If the sale should be submitted early, dispatch the saleSubmittedEarly action
   * and submit the sale before navigating.
   */
  const goConfirmation = () => {
    // Sale-less ABP: skip early submission — no carrier sale exists, so
    // submitSale() would log a spurious error about missing sale status.
    if (
      saleManager.shouldSubmitSaleEarly() &&
      !payAccountBalance?.abpTransactionId
    ) {
      dispatch(saleSubmittedEarly())
      saleManager.submitSale()
    }
    $state.go(STATES.SALE_CONFIRMATION)
  }

  return goConfirmation
}
